
const isLoggedIn = () => {
  let logged = false;
  if(localStorage.getItem('jwttoken') != null) {
    logged = true;
  }
  return logged;
}
export {isLoggedIn};
